// extracted by mini-css-extract-plugin
module.exports = {"button":"RevealButton-module__button___2BKhp","icon":"RevealButton-module__icon___1M1N5"};